import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { ProductFeatureConfig } from '../../../types/insurances/ProductFeatureConfig';
import { product as base } from './base';
import { product as CZ } from './CZ';
import { product as HR } from './HR';
import { product as HU } from './HU';
import { product as RO } from './RO';
import { product as SK } from './SK';

export const productConfig: InsuranceIndex<ProductFeatureConfig> = { base, CZ, HR, HU, RO, SK };
